import React, {
    useCallback,
    useState,
} from 'react'
import PropTypes from 'prop-types'
import {
    Button,
    TextField,
} from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'
import { textFieldStyle } from 'shared/TextStepField/TextStepField.style'
import PictureLayout from 'shared/PictureLayout/PictureLayout'
import styles from './SkippableCommentPicture.style'

const propTypes = {
    image: PropTypes.string.isRequired,
    onAdd: PropTypes.func.isRequired,
    onSkip: PropTypes.func.isRequired,
    isRequired: PropTypes.bool.isRequired,
    isNested: PropTypes.bool,
}

const SkippableCommentPicture = ({
    image,
    onAdd,
    onSkip,
    isRequired,
    isNested = false,
}) => {
    const { t } = useTranslation()
    const classes = useStyle(styles)
    const textFieldStyles = useStyle(textFieldStyle)

    const [
        comment,
        setComment,
    ] = useState('')

    const onTextChange = useCallback((event) => {
        setComment(event.target.value)
    }, [])

    const onAddClick = useCallback(() => {
        onAdd(comment)
    }, [
        onAdd,
        comment,
    ])

    return (
        <PictureLayout
            title={t('ADD_COMMENT')}
            image={image}
            isRequired={isRequired}
            isAnswered
            isNested={isNested}
        >
            <div css={classes.text}>
                <TextField
                    id="outlined-helperText"
                    value={comment}
                    fullWidth
                    multiline
                    rows={7}
                    size="small"
                    sx={textFieldStyles}
                    variant="outlined"
                    onChange={onTextChange}
                />
                <div css={classes.buttons}>
                    <Button
                        data-testid="add-button"
                        css={classes.button}
                        onClick={onAddClick}
                    >
                        {t('ADD')}
                    </Button>
                    <Button
                        data-testid="skip-button"
                        css={classes.button}
                        onClick={onSkip}
                    >
                        {t('SKIP')}
                    </Button>
                </div>
            </div>
        </PictureLayout>
    )
}

SkippableCommentPicture.propTypes = propTypes

export default SkippableCommentPicture
